import styled from 'styled-components'
import { Card , } from 'antd'

export const StyledOptonHader = styled(Card)`
  margin-bottom: 220px !important;
  
  &.pinned {
    max-height: 350px;
    min-height: 350px;
    overflow-y: scroll;
    margin-bottom: 0px !important;
  }

  .ant-card-body {
      padding: 26px 15px;
  }
  
  &.trade-open {
    margin-right: 600px;
  }

  .bg-header{
      background-color: #4a4a4a;
      border-bottom: 1px solid #d9d9d9;
      color: #ffffff;
      font-size: 14px;
      
      table{
        td{
            border-right: 1px solid #5b5b5b;
            padding: 0 5px;
            height: 25px;
            width: 53px;
        }
        .td-3{
          color: #f95f5f;
          font-weight: 600;
        }
        .up-down-number{
          color: #f95f5f;
          p{
              margin-bottom: 0rem;
              line-height: 1rem;
          }
        }
      }
  }

  .bg-collheader{
      background-color: #1c1c1c;
      color: #667071;
      font-size: 12px;
      text-align: center!important;
      
      .ant-select-selection.ant-select-selection--single{
          height: 20px !important;
      }
     
      .ant-select-sm .ant-select-selection__rendered {
          line-height: 18px !important;
      }
      
      .ant-select{
          font-size: 12px;
      }

    .divrow {
      > div {
            border-color: #3a3333;
            font-size: 15px;
            color: #fff;
          }
    }
  }
  
  .ant-collapse-content>.ant-collapse-content-box {
    padding: 0;
  }
  
  .ant-collapse-content{
      padding: 0px 1px;
  }
  .divrow { 
    display: flex;
    > div { 
        flex: 1 1 0%;
        border: 1px solid rgb(238, 238, 238);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
        font-size: 12px;
        &.black { 
            background: #d2d2d2;
            border-color: #f3ebeb;
        }
        &.blue { 
            background: #cccce2;
        }
    }
  }
  .ant-collapse>.ant-collapse-item>.ant-collapse-header { 
    padding: 5px 0 5px 40px;
    .arrow { 
      line-height: 32px;
    }
  }
  
  .book-list{
      overflow-y: auto;
      ::-webkit-scrollbar {
          display: none;
      }
      .divrow { 
       &:hover { 
         > .bg-black {
            background-color: #237a92 !important;
            border-color: #237a92;
            color: #fff1f1;
         }
         > .bg-blue {
            background-color: #000 !important;
            border-color: #021529;
            color: #fff1f1;
         }
       }
    }
  }
  
  .date-select { 
    padding-bottom: 15px;
  }
  
  .trade-builder {
    font-size: 11px;
    padding: 5px 10px;
    border-radius: 0;
    margin-top: 10px;

  }
  .tradediv {
    position: fixed;
    width: calc(100vw - 250px);
    left: 0;
    z-index: 999;
    border: solid 4px #1890ff;
    bottom: 0;
    left: 218px;
    background: #fff;
    
    .ant-table-body {
      overflow-x: hidden !important;
    }
    .ant-table-header {
      overflow: hidden !important;
      height: 60px;
    }
    
    h1 {
        font-size: 15px;
        margin: 0;
        padding: 8px;
        background: #1890ff;
        color: #fff;
        
        .anticon-close {
          position: absolute;
          right: 0;
          cursor: pointer;
        }
        .dock-Pin {
          margin-right: 15px;
        }
    }
    
    .ant-table-tbody>tr>td, .ant-table-thead>tr>th {
      padding: 2px 0px;
      word-break: break-all;
      text-align: center;
    }
    
    .footer {
      width: 100%;
      text-align: right;
      padding: 5px 0;
      padding-right: 65px;
      
      button {
        margin-right: 3px;
      }
    }
    
  }
  
  .trade-btn {
    position: fixed;
    bottom: 64px;
  }
  
}
  
`


// WEBPACK FOOTER //
// ./src/components/option-book/style.js